import {
    ProductAttributeType, StyledAttributeItem
} from "../tabs/ProductAttributes";
import ProductAttributeNameItem from "./items/ProductAttributeNameItem";
import ProductAttributeValueItem from "./items/ProductAttributeValueItem";

type ProductStringItemProps = {
    attr: ProductAttributeType
}

const ProductAttributeString = ({attr}: ProductStringItemProps) => {
    return (
        <StyledAttributeItem repeat={2}>
            <ProductAttributeNameItem attr={attr}/>
            <ProductAttributeValueItem type='select' attr={attr} />
        </StyledAttributeItem>
    );
};

export default ProductAttributeString;
